import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './menugroup-model';  //editable..
import MenuChecklist from '../menu/menu-checklist.component';
import OwnerChecklist from '../owner/owner-checklist.component';
import UserChecklist from '../user/user-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class MenugroupDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }                
                <InputPicklist name='menu' label='Menu Access List' value='' caption={this.state.datarow.menuCaption} readOnly={this.state.datarow.menu? false: true} disableAutoClose>
                    <MenuChecklist history={this.props.history} currentId={this.state.datarow.menu} readOnly disableBackButton/>
                </InputPicklist> 
                {AppService.isAppFullVersion() &&
                <InputPicklist name='accessowner' label='Owner Access List' value='' caption={this.state.datarow.accessownerCaption} readOnly={this.state.datarow.accessowner? false: true} disableAutoClose>
                    <OwnerChecklist history={this.props.history} currentId={this.state.datarow.accessowner} readOnly disableBackButton/>
                </InputPicklist> 
                }
                <InputPicklist name='users' label='User Access List' value='' caption={this.state.datarow.userCaption} readOnly={this.state.datarow.users? false: true} disableAutoClose>
                    <UserChecklist history={this.props.history} currentId={this.state.datarow.users} readOnly disableBackButton/>
                </InputPicklist>
                <Input name='icon' label='Icon' value={this.state.datarow.icon} readOnly/>
                
            </BaseDelete>
        );
    }
}